import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { shapeNames } from 'ui/workflows/flowchart';
import noop from 'utils/noop';
import { updateNode } from '../../ducks';
import { NoteNode } from '../../types';
import { InlineEditStyled } from './WorkflowFlowchart.styles';
import { isNodeInlineEditEnabled } from './WorkflowFlowchart.utils';

export const NOTE_BODY_MAX_LENGTH = 500;
interface NotesInlineEditProps {
  // Callback specifying if inline edit is in progress or not
  onEditStateChange: (isEditInProgress: boolean) => void;
}

const NotesInlineEditCmp = ({ onEditStateChange = noop }: NotesInlineEditProps) => {
  const dispatch = useDispatch();
  const shouldInlineEditBegin = useCallback(
    (e: any) => isNodeInlineEditEnabled(e.item?.getModel()),
    [],
  );
  const handleOnInlineEditUpdate = useCallback(
    (e: any) => dispatch(updateNode(e.data, e.id)),
    [dispatch],
  );

  const updateInlineEditState = useCallback(
    (id: any, isInlineEditInProgress: any) => {
      dispatch(
        updateNode(
          {
            isInlineEditInProgress,
            // set to null if false so that it doesn't interfere with
            // hover/selected state functions
            isActive: isInlineEditInProgress === true ? isInlineEditInProgress : null,
            isSelected: isInlineEditInProgress === true ? isInlineEditInProgress : null,
          } as Partial<NoteNode>,
          id,
        ),
      );
      onEditStateChange(isInlineEditInProgress);
    },
    [dispatch, onEditStateChange],
  );

  const handleInlineEditBegin = useCallback(
    ({ id }: any) => updateInlineEditState(id, true),
    [updateInlineEditState],
  );
  const handleInlineEditEnd = useCallback(
    ({ id }: any) => updateInlineEditState(id, false),
    [updateInlineEditState],
  );

  return (
    <InlineEditStyled
      inputProps={{ maxLength: NOTE_BODY_MAX_LENGTH }}
      isCharacterCountShown={true}
      property={'body'}
      shapeClassName={shapeNames.body}
      shouldBegin={shouldInlineEditBegin}
      onUpdate={handleOnInlineEditUpdate}
      onBegin={handleInlineEditBegin}
      onEnd={handleInlineEditEnd}
    />
  );
};

export const NotesInlineEdit = React.memo(NotesInlineEditCmp);

export default NotesInlineEdit;
